import React from "react"
import Box from "@mui/material/Box";
import Radio from '@mui/material/Radio';
import { useSelector } from "react-redux";
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import { H3 } from "../../../components/headings"
import { getGiftAidAmount } from "../../../helpers";
import { AddressForm } from "../../../components/AddressForm";
import GiftAidImage from "../../../assets/images/gift-aid-uk.png"
import { CheckboxWithLabel, LongText } from "../../../components"

export default function ({ handleChange, validationErrors, }) {
    const state = useSelector(state => state.donationCheckout);

    const selectedCurrencySymbol = state.selectedCountry.currency.symbol;
    const { makeGiftAidDonation, sameBillingForGiftAid, donationAmount } = state;
    const totalDonationWithGiftAid = getGiftAidAmount(donationAmount) + Number(donationAmount);
    const assignClasses = makeGiftAidDonation ? "gift-box-outer yellow" : "gift-box-outer";

    return <Box id="giftAidAddress">
        {/* <FormHeading heading="Make Gift Aid donation" /> */}
        <div id="reclaim_gift_aid_div" className={assignClasses}>
            <div className="gift-box-inner">
                <div className="gift-box-top-area">
                    <div className="gift-box-top-left">
                        <H3 content={`Choose Gift Aid and increase the value of your ${selectedCurrencySymbol}
                                ${donationAmount} donation to ${selectedCurrencySymbol} ${totalDonationWithGiftAid} at no extra cost to you`} />
                        <CheckboxWithLabel checkboxStyles={{ color: 'neutral.dark' }} nameAndId={"makeGiftAidDonation"} label="I'd like to make this a Gift Aid donation" handleCheck={handleChange} />
                    </div>

                    <div className="gift-box-top-right">
                        <img className="br-radius img-fluid" src={GiftAidImage} />
                    </div>
                </div>

                <div className="gift-box-bottom-area">
                    <LongText className={"text"}
                        content="YES, I want to Gift Aid this donation and any future donations 
                    I make in the future or have made in the past four years to The Citizens Foundation (UK).
                    TCF-UK will reclaim 25p on every £1 I give. <br /><br />By ticking this box, 
                    I confirm that I am a UK taxpayer and understand that if I pay less Income Tax and/or 
                    Capital Gains Tax in the current tax year than the amount of Gift Aid claimed on all my 
                    donations it is my responsibility to pay the difference.<br /><br />Please note, 
                    your address is required to identify you as a UK taxpayer."
                        renderhtml={true}
                        limit={187} />
                </div>
            </div>

            {makeGiftAidDonation && <div id="giftadd_div" className="gift-add-addr">
                <FormControl sx={{ '& .MuiFormLabel-root.Mui-focused, .MuiFormLabel-root': { color: 'black' } }}>
                    <FormLabel>Gift Aid Address</FormLabel>
                    <RadioGroup value={sameBillingForGiftAid} onChange={handleChange} name="sameBillingForGiftAid">
                        <FormControlLabel value={1} control={<Radio />} label="Please use the billing details address" />
                        <FormControlLabel value={0} control={<Radio />} label="I'd like to use another address" />
                    </RadioGroup>
                </FormControl>
            </div>
            }
            {
                makeGiftAidDonation && !sameBillingForGiftAid &&
                <div style={{ padding: '15px' }}>
                    <AddressForm name="giftAidBilling" addressDetails={state.giftAidBilling} updateAddressDetails={handleChange} validationErrors={validationErrors} />
                </div>
            }
        </div>
    </Box>
}